function getOffset(chIndex) {
  const aCode = 'A'.charCodeAt(0);
  const lCode = 'L'.charCodeAt(0);
  const vCode = 'V'.charCodeAt(0);
  if (chIndex >= vCode) return 3;
  if (chIndex >= lCode) return 2;
  if (chIndex > aCode) return 1;
  return 0;
}


function containerNumberValidator(number) {
  if (!number || number.length !== 11) {
    return false;
  }

  const aCode = 'A'.charCodeAt(0);
  const zeroCode = '0'.charCodeAt(0);

  let total = 0;
  for (let i = 0; i < 10; ++i) {
    const ch = number[i];
    const chCode = ch.charCodeAt(0);
    let chIndex = null;

    if (i < 4) {
      if (ch >= 'A' && ch <= 'Z') chIndex = 10 + (chCode - aCode + getOffset(chCode));
    } else if (ch >= '0' && ch <= '9') chIndex = (chCode - zeroCode);

    if (chIndex === null) return false;
    total += chIndex * (2 ** i);
  }
  let checkNumber = total % 11;
  if (checkNumber === 10) checkNumber = 0;

  return String(checkNumber) === number[10];
}

export default containerNumberValidator;
